import React, { useState, useEffect, useContext } from 'react';
// Make sure to import the CSS file as previously discussed
import { PracticeJerseyOrderContext } from './PracticeJerseyBuilder';

export function parseNumberList(input) {
    // Split input by commas to handle individual numbers and ranges separately
    const parts = input.split(',');
    const numbers = [];

    parts.forEach(part => {
        // Check if part is a range
        if (part.includes('-')) {
            // Split the range into start and end numbers
            const [start, end] = part.split('-').map(Number);
            // Generate all numbers in the range and add to the numbers array
            for (let i = start; i <= end; i++) {
                numbers.push(i);
            }
        } else {
            // It's a single number, add it to the numbers array
            numbers.push(Number(part));
        }
    });

    // Return the array of numbers, ensuring uniqueness and sorting
    return [...new Set(numbers)].sort((a, b) => a - b);
}

export const createNumberList = (numbers = []) => {
    // Create a string with the numbers separated by commas
    if (typeof numbers != 'array') {
        return '';
    }
    return numbers.join(',');
};

const SizeOption = ({ size, handleSetSize, autoSequence, includeNames, includeNumbers, productNum }) => {

    const { sizeData } = useContext(PracticeJerseyOrderContext);

    const [hasSize, setHasSize] = useState(""); // Assuming this state has its purpose beyond the provided snippet
    const [thisSizeData, setThisSizeData] = useState({}); // Assuming this state has its purpose beyond the provided snippet
    const [includeOption, setIncludeOption] = useState(false); // State to manage the new checkbox
    // Handlers for the checkboxes and quantity
    const handleIncludeOptionChange = () => {
        setIncludeOption(!includeOption);
    };

    const handleNumberOptions = (value) => {
        setHasSize(value);
        let numbers = parseNumberList(value);
        doSizeUpdate(numbers.length, numbers);


    };

    const updateNumber = (number, index) => {
        // eliminate anything but a numeric value
        number = number.replace(/\D/g, '');

        //if it is a 0 or 00 return 00
        if (number === '0' || number === '00') {
            number = '00';
        }

        //only allow 3 numbers
        if (number.length > 3) {
            number = number.slice(0, 3);
        }

        let numbers = thisSizeData.sizeNumbers?.length > 0 ? thisSizeData.sizeNumbers : Array.from({ length: thisSizeData.qty }, (_, i) => i + 1);
        numbers[index] = number;
        doSizeUpdate(thisSizeData.qty, numbers);
        console.log('NUMBERS ARE:', numbers)
    }

    const updateName = (name, index) => {
        console.log(name, index, 'update name')
        let names = thisSizeData.sizeNames?.length > 0 ? thisSizeData.sizeNames : Array.from({ length: thisSizeData.qty }, (_, i) => i + 1);
        names[index] = name;
        doSizeUpdate(thisSizeData.qty, thisSizeData.sizeNumbers, names);
        console.log('NAMES ARE:', names)
    }

    const doSizeUpdate = (qty, numbers, names) => {
        let newSizeData = {
            size: size,
            sizeNames: thisSizeData.sizeNames || [],
            sizeNumbers: thisSizeData.sizeNumbers || [],
        }
        newSizeData.qty = qty || thisSizeData.qty;
        newSizeData.sizeNumbers = numbers || thisSizeData.sizeNumbers;
        newSizeData.sizeNames = names || thisSizeData.sizeNames;
        setThisSizeData(newSizeData);
        console.log(newSizeData, 'newSizeData', sizeData, size)
        handleSetSize(size, newSizeData.qty, newSizeData.sizeNumbers, newSizeData.sizeNames);
    }

    const updateQty = (qty = 0) => {
        if (qty < 0) {
            qty = 0;
        }
        doSizeUpdate(qty);
    }

    useEffect(() => {
        let sizeNumbers = thisSizeData.sizeNumbers;
        let quantity = thisSizeData.qty;
        if (includeOption && !quantity) {
            doSizeUpdate(1, sizeNumbers);

        } else {
            if (!includeOption) {
                handleSetSize(size, 0);
            }
        }
    }, [includeOption]);


    useEffect(() => {

        const thisSizeData = sizeData.find((data) => data.size === size)
        console.log(thisSizeData, 'thisSizeData', sizeData, size)
        setThisSizeData(thisSizeData || {});
        if (thisSizeData && thisSizeData.qty > 0) {
            setIncludeOption(true);
        } else {
            setIncludeOption(false);
        }
    }, [sizeData]);

    useEffect(() => {

        if (!autoSequence) {
            setHasSize(createNumberList(thisSizeData.sizeNumbers));
        }
    }, [autoSequence]);


    return (
        <div className="size-option" key={`size-option${size}-${productNum}`} id={`size-option${size}-${productNum}`}>
            <div className="size-header">
                <div className="include-option">
                    <input
                        type="checkbox"
                        id={`include-option-${size}`}
                        checked={includeOption}
                        onChange={handleIncludeOptionChange}
                    />
                </div>
                <h3><label htmlFor={`include-option-${size}`}>Size <b>{size}</b></label></h3>
                <div className="options">
                    {includeOption && <div className="qty">
                        {(autoSequence || includeNames) && <button onClick={() => updateQty(thisSizeData.qty - 1)}>-</button>}
                        <input type="number" onChange={(e) => updateQty(e.target.value)} value={thisSizeData.qty} />
                        {(autoSequence || includeNames) && <button onClick={() => updateQty(thisSizeData.qty + 1)}>+</button>}
                    </div>
                    }
                </div>
            </div>
            <div className="size-body">

                {includeNames && includeOption ?
                    Array.from({ length: thisSizeData.qty }, (_, i) => i + 1).map((i) => (
                        <div key={size + i} className="d-flex w-100 name-number">
                            {
                                autoSequence ?
                                    <input type="text" className={`${size}-size-number`} id={`${size}-${i}-num`} value={thisSizeData.sizeNumbers ? thisSizeData.sizeNumbers[i - 1] : i} style={{ width: "50px" }} />
                                    : <input type="text" value={thisSizeData.sizeNumbers ? thisSizeData.sizeNumbers[i - 1] : i} style={{ width: "50px" }} onChange={(e) => updateNumber(e.currentTarget.value, i - 1)} />
                            }
                            {thisSizeData.sizeNames && <input type="text" defaultValue={thisSizeData.sizeNames[i - 1] || ""} onChange={(e) => updateName(e.target.value, i - 1)} />}
                        </div>
                    ))
                    :
                    includeOption && includeNumbers && !autoSequence && <><input type="text" placeholder="Enter Numbers" className="numbers-input" onChange={(e) => handleNumberOptions(e.target.value)} value={hasSize} />
                        <span>Enter your numbers with either 1, 2, 4 format or 1-3 format or a combination of both: 2,8,10-15</span>
                    </>
                }
                {
                    includeOption && !includeNames && includeNumbers && (
                        <>
                            <div className="Heading">
                                Selected Numbers
                            </div>
                            {thisSizeData?.sizeNumbers && thisSizeData?.sizeNumbers.length > 0 && (<div className="d-flex w-100 number-list">
                                {
                                    thisSizeData?.sizeNumbers.map((number, i) => {
                                        return <div key={size + i} className="d-flex name-number">
                                            {number}
                                        </div>
                                    })
                                }
                            </div>)
                            }
                        </>
                    )
                }
            </div>
        </div>
    );
};

export default SizeOption;
